import { Paragraph } from "@smartsuite/react-ui/lib";
import React from "react";

export const ErrorPage: React.FC = () => {
  return <Paragraph>Not found</Paragraph>;
};
